<template>
  <div class="described-wish">
      <img class="close" alt="Vue logo" src="../assets/close.png" v-on:click="$emit('close')"/>
      <p class="wish-name">{{ wish.label }}</p>
      <p class="wish-size" v-if="hasSize">Taille : {{ wish.size }}</p>
      <img class="pic" alt="Vue logo" :src="img"/>
      <p class="wish-description">{{ wish.description }}</p>
  </div>
</template>

<script>
// { "priority": 100, "owner": "David", "price": 1000, "id": "kdo1", "label": "A Super Cadeau" }
export default {
  props: ["wish"],
  data() {
      return {
        defaultImage: require("@/assets/cadeau.jpg")
      }
  },
  computed: {
      img: function() {
          return (this.wish.picture === undefined) ? this.defaultImage : this.wish.picture 
      },
      hasSize() {
          return !(this.wish.size === undefined || this.wish.size === "")
      }
  }
}
</script>

<style scoped>
    .pic {
        width: 300px;
    }
    .close {
        width: 30px;
        float: right;
    }
</style>
